import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { NCBAccount } from "@nocodebackend/account-react";
import { useAuth } from "../context/AuthContext";

const ADMIN_EMAIL = "doc@eidoc.com.br";

export default function AppLayout({ children }) {
  const { profile, user, signOut } = useAuth();
  const navigate = useNavigate();
  async function leave() { await signOut(); navigate("/entrar"); }
  return (
    <div className="app-shell">
      <header className="app-header">
        <Link className="marca" to="/app">DiárioMed</Link>
        <nav className="nav-main">
          <Link to="/app">Painel</Link>
          <Link to="/app/novo">Novo acompanhamento</Link>
          <Link to="/app/plano">Plano</Link>
          {user?.email?.toLowerCase() === ADMIN_EMAIL && <Link to="/app/admin">Administrar contas</Link>}
        </nav>
        <div className="app-identidade"><span>{profile?.name}</span><NCBAccount /><button className="botao-link" onClick={leave}>Sair</button></div>
      </header>
      <main className="app-conteudo">{children}</main>
    </div>
  );
}
